import "./Solutions.module.css";
import Header from "@/reusable_sections/Header";
import ScienceAndTechnology from "./sections/ScienceAndTechnology";
import YeuCauTuVan from "./sections/YeuCauTuVan";
import Footer from "@/reusable_sections/Footer";
export default function SolutionsPage() {
  return <div>
      <Header />
      <ScienceAndTechnology />
      <YeuCauTuVan />
      <Footer />
    </div>;
}